import { Dictionary } from 'lodash'

import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

type FeaturesByName = Dictionary<{ id: string; enabled: boolean; name: string }[]>

class AttendanceFeaturesUtils {
  static hasWorkedTimeMaterialized(featureByName: FeaturesByName): boolean {
    return (
      TimesheetFeatures.MATERIALIZED_DATA in featureByName ||
      TimesheetFeatures.MATERIALIZED_WORKED_TIME_CLICKHOUSE in featureByName
    )
  }

  static hasBalanceMaterialized(featureByName: FeaturesByName): boolean {
    return TimesheetFeatures.MATERIALIZED_BALANCE_DATA in featureByName
  }

  static hasPaidBreaks(featureByName: FeaturesByName): boolean {
    return TimesheetFeatures.PAID_BREAKS in featureByName
  }
}

export default AttendanceFeaturesUtils
